import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  successData: false,
  documentTypes: [],
  countryPhones: [],
  genders: [],
  ipss: [],
  ratePlans: [],
  ethnicities: [],
  specialties: [],
  surgeries: [],
  doctors: [],
  headquarters: [],
  procedures: [],
  errorMessage: undefined,
};

export const selectFormSlice = createSlice({
  name: "selectForm",
  initialState,
  reducers: {
    onLoadDocumentTypes: (state, { payload }) => ({
      ...state,
      isLoading: true,
      documentTypes: payload,
    }),
    onLoadCountryPhones: (state, { payload }) => ({
      ...state,
      isLoading: true,
      countryPhones: payload,
    }),
    onLoadGenders: (state, { payload }) => ({
      ...state,
      isLoading: true,
      genders: payload,
    }),
    onLoadIpss: (state, { payload }) => ({
      ...state,
      isLoading: true,
      ipss: payload,
    }),
    onLoadRatePlans: (state, { payload }) => ({
      ...state,
      isLoading: true,
      ratePlans: payload,
    }),
    onLoadEthnicities: (state, { payload }) => ({
      ...state,
      isLoading: true,
      ethnicities: payload,
    }),
    onLoadSpecialties: (state, { payload }) => ({
      ...state,
      isLoading: true,
      specialties: payload,
    }),
    onLoadSurgeries: (state, { payload }) => ({
      ...state,
      isLoading: true,
      surgeries: payload,
    }),
    onLoadDoctors: (state, { payload }) => ({
      ...state,
      isLoading: true,
      doctors: payload,
    }),
    onLoadHeadquarters: (state, { payload }) => ({
      ...state,
      isLoading: true,
      headquarters: payload,
    }),
    onLoadProcedures: (state, { payload }) => ({
      ...state,
      isLoading: true,
      procedures: payload,
    }),
    onFailedLoad: (_, { payload }) => ({
      ...initialState,
      isLoading: false,
      errorMessage: payload,
    }),
    onSuccessLoad: (state) => ({
      ...state,
      isLoading: false,
      successData: true,
    }),
    isLoadingData: (state) => ({
      ...state,
      isLoading: true,
      successData: false,
    }),
  },
});

// Action creators are generated for each case reducer function
export const {
  onLoadDocumentTypes,
  onLoadCountryPhones,
  onLoadGenders,
  onLoadIpss,
  onLoadRatePlans,
  onLoadEthnicities,
  onLoadSpecialties,
  onLoadSurgeries,
  onLoadDoctors,
  onLoadHeadquarters,
  onLoadProcedures,
  onFailedLoad,
  onSuccessLoad,
  isLoadingData,
} = selectFormSlice.actions;
